<template>
  <button
    type="button"
    :class="`vf-btn ${size} ${variant} ${busy ? 'busy' : ''}`"
    :disabled="disabled || busy ? true : false"
    @click="handleClick"
  >
    <slot></slot>
    <spinner-wrapper
      v-if="busy"
      :size="SpinnerSize.M"
      :style="{
        position: 'absolute',
      }"
    />
  </button>
</template>

<script lang="ts" setup>
  import { ButtonSize, ButtonVariant } from './VfButton.types';
  import { SpinnerSize } from '../SpinnerWrapper/SpinnerWrapper.types';

  const {
    size = ButtonSize.MEDIUM,
    variant = ButtonVariant.PRIMARY,
    busy = false,
    disabled = false,
  } = defineProps<{
    size?: ButtonSize;
    variant?: ButtonVariant;
    busy?: boolean;
    disabled?: boolean;
  }>();

  const emit = defineEmits<{ (e: 'click', payload?: MouseEvent): void }>();

  const handleClick = (event: MouseEvent) => {
    emit('click', event);
  };
</script>

<style lang="scss" scoped>
  .busy {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    color: transparent;
  }

  .vf-btn--sm {
    font-size: 0.6rem;
    padding: 5px 35px;
    border-width: 1.5px;
  }

  .vf-btn__primary {
    background-color: $primary-button-color;
    color: white;

    &:hover {
      background-color: $primary-button-color-hover;
    }
  }

  .vf-btn__secondary {
    background-color: $secondary-button-color;

    &:hover {
      background-color: $secondary-button-color-hover;
    }
  }

  .vf-btn__tertiary {
    border-color: $tertiary-button-color !important;
    color: $tertiary-button-color;

    &:hover {
      color: $tertiary-button-color;
      background-color: transparent;
    }
  }

  // Slight modification of tertiary variant
  .vf-btn__quaternary {
    color: $quaternary-button-color;
    border-color: $quaternary-button-color !important;

    &:hover {
      color: $quaternary-button-color;
      background-color: transparent;
    }
  }
</style>
